import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

// Tracks the current leaflet-rotate map bearing (so the direction cone can
// compensate for it) and resets the bearing to north when asked.
//
// The "reset to north" behaviour relies on a version-token handshake: the
// recenter button increments `resetVersion`, and this component watches for
// that change and calls `setBearing(0)`. Guard this behaviour with the test in
// `MapBearingSync.test.tsx` so a future refactor can't silently break it.
export function MapBearingSync({
  onBearingChange,
  resetVersion,
}: {
  onBearingChange: (deg: number) => void;
  resetVersion: number;
}) {
  const map = useMap();
  const lastReset = useRef(resetVersion);

  useEffect(() => {
    const anyMap = map as any;
    const report = () => {
      if (typeof anyMap.getBearing === "function") {
        onBearingChange(anyMap.getBearing() || 0);
      }
    };
    map.on("rotate", report);
    report();
    return () => {
      map.off("rotate", report);
    };
  }, [map, onBearingChange]);

  useEffect(() => {
    if (resetVersion === lastReset.current) return;
    lastReset.current = resetVersion;
    const anyMap = map as any;
    if (typeof anyMap.setBearing === "function") {
      try {
        anyMap.setBearing(0);
      } catch {
        // Rotation unsupported at runtime — nothing to reset.
      }
    }
  }, [map, resetVersion]);

  return null;
}
